import useInterval from 'hooks/useInterval'
import type { DateDifference } from 'lib/datetime/dateUtils'
import { dateDifference } from 'lib/datetime/dateUtils'
import { memo, useState } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'

const FixedWidthCountdown = styled.span`
  display: inline-block;
  width: 7ch;
`

interface Props {
  salesEndDate: string
}

function OfferCalendarFlightDealBannerCountdown(props: Props) {
  const intl = useIntl()
  const { salesEndDate } = props
  const [timeRemaining, setTime] = useState<DateDifference>(dateDifference(new Date(salesEndDate)))

  useInterval(() => {
    setTime(dateDifference(new Date(salesEndDate)))
  }, 1000, { disabled: new Date() > new Date(salesEndDate) })

  const formattedTime = [timeRemaining.hours, timeRemaining.minutes, timeRemaining.seconds]
    .map(n => String(Math.max(n, 0)).padStart(2, '0'))
    .join(':')

  if (timeRemaining.days < 1) {
    return <FixedWidthCountdown>{formattedTime}</FixedWidthCountdown>
  }

  return <>{intl.formatMessage(
    {
      id: '1XhFW0vgOpWKFptT6mFY',
      defaultMessage: '{days} days',
    },
    { days: timeRemaining.days },
  )}
  </>
}

export default memo(OfferCalendarFlightDealBannerCountdown)
